var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"item"},[_c('el-form-item',{ref:"name",staticClass:"input",attrs:{"label":_vm.schema.name.lbl,"rules":_vm.rules[`${_vm.item.id}__name`],"prop":`${_vm.item.id}__name`}},[_c('Input',{attrs:{"field":{
            ..._vm.schema.name,
            name: `${_vm.item.id}__name`
          },"model":_vm.item.fields[0].value},on:{"set-value":(name, val) =>
              _vm.handleChange({
                [_vm.schema.name.name]: val
              })}})],1)],1),_c('div',{staticClass:"item"},[_c('el-form-item',{ref:"position",staticClass:"input",attrs:{"label":_vm.schema.position.lbl,"rules":_vm.rules[`${_vm.item.id}__position`],"prop":`${_vm.item.id}__position`}},[_c('Input',{attrs:{"field":{
            ..._vm.schema.position,
            name: `${_vm.item.id}__position`
          },"model":_vm.item.fields[1].value},on:{"set-value":(name, val) =>
              _vm.handleChange({
                [_vm.schema.position.name]: val
              })}})],1)],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"item"},[_c('el-form-item',{ref:"organization",staticClass:"input",attrs:{"label":_vm.schema.organization.lbl,"rules":_vm.rules[`${_vm.item.id}__organization`],"prop":`${_vm.item.id}__organization`}},[_c('Input',{attrs:{"field":{
            ..._vm.schema.organization,
            name: `${_vm.item.id}__organization`
          },"model":_vm.item.fields[2].value},on:{"set-value":(name, val) =>
              _vm.handleChange({
                [_vm.schema.organization.name]: val
              })}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }